<template>
    <div class="bg-white p-4">
      <TsIcon name="bitcoin-icons:cross-filled" data-testid="savelist-share-close-icon"
        class="absolute top-3 right-3 text-idle-black hover:bg-info/10 rounded transition-colors cursor-pointer"
        @click="emit('close')" />
      <template v-if="props.savelistCode">
        <div class="md:p-4">
        <TsTypography variant="h2" weight="semibold" append-class="mt-1 mb-8 leading-4 text-idle-black">
          {{useTranslation("shareSaveList" , "Deel kluslijst")}}
        </TsTypography>
  
        <div class="flex flex-col gap-4 justify-between bg-idle-white">
          <TsLabel :label= "useTranslation('copyUrlAndShare' , 'Kopieer URL en deel')" :inputValue="fullTrolleyUrl" floating  labelClass="!bg-white">
           
            <TsInput appendClass="pr-0.5 py-0.5 " readonly :value="fullTrolleyUrl">
              <template #right>
                <TsTooltip :text="copied ? useTranslation('copied', 'gekopieerd') : useTranslation('copy', 'Kopieer')" root-class="p-2" append-class="p-0">
                  <TsButton :icon="copied ? 'tabler:copy-check' : 'tabler:copy'" :variant="copied ? 'success' : 'info'"
                    @click="handleShareClick(fullTrolleyUrl)" data-testid="savelist-share-copy-button" />
                </TsTooltip>
              </template>
            </TsInput>
          </TsLabel>
        </div>
      </div>
      </template>
      <div v-else class="h-[354px] grid place-items-center text-idle-black">
        <TsAnimatedBubbleLoader size="40" class="text-natural-grey" />
      </div>
    </div>
  </template>
  
  <script lang="ts" setup>

  import { useTranslation } from "~/composables/useTranslation";
  const useQRCode = () => import('@vueuse/integrations/useQRCode')

  const TsTooltip = defineAsyncComponent(
      () => import('~/components/atoms/TsTooltip.vue')
  );

const TsAnimatedBubbleLoader = defineAsyncComponent(
  () => import('~/components/atoms/icons/TsAnimatedBubbleLoader.vue')
);

  type Props = {
    savelistCode: string;
    trolleyCode?: string;
  };
  
  const trolleyStore = useTrolleyStore();
  const savelistStore = useSavelistStore();
  
  const props = withDefaults(defineProps<Props>(), {});
  
  const emit = defineEmits<{
    emailSubmit: [email: string];
    close: boolean | any;
  }>();
  
  const savelistQrImage = ref("");
  
  if (import.meta.client && savelistStore.encoded_savelist_url)
  savelistQrImage.value = window.atob(savelistStore.encoded_savelist_url);
  
  const fullTrolleyUrl = computed(() => {
        const baseUrl = `${window.location.origin}/`; // Get the base URL dynamically
        return `${baseUrl}save-list-code/?s=${unref(savelistStore.encoded_savelist_url)}`;
      });
  
  const encodedSavelistUrl = computed(() => {
    return savelistStore.encoded_savelist_url;
  });
  
  const { copy, copied } = useClipboard({
    source:encodedSavelistUrl,
    legacy: true,
    copiedDuring: 2000,
  });
  
  defineOptions({
    inheritAttrs: false,
  });

  const handleShareClick= (fullTrolleyUrl: string)=>{
    copy(fullTrolleyUrl)
    logEvent({
        options: {
          eventAction: "click",
          eventProperties:"",
          ecommerce: { method: 'copy', content_type: 'url', item_id: props.savelistCode || 'N/A' },
          eventInteraction: true,
          eventLabel: `user share this ${props.savelistCode} item_id`,
          eventName: "share",
        },
      });
  }
  </script>
  